import DateTimeUtil from '@/util/DateTimeUtil'

var DateTimeUtilsMixin = {
  filters: {
    humanizeDuration: function (duration, options = {}) {
      if (duration) {
        return DateTimeUtil.humanizeDurationPrecisely(duration, options)
      }
    }
  }
}

export default DateTimeUtilsMixin
